import { useState } from 'react'
import { useBrandColors } from '../../hooks/useBrandColors'

export default function Performance() {
  const { accent, accentLight, accentBg } = useBrandColors()
  const [activeTab, setActiveTab] = useState('warnings')
  const [modal, setModal] = useState(null)
  const [warnings, setWarnings] = useState([
    { id: 0, name: 'Marcus Thomas', initials: 'MT', dept: 'Operations', num: 3, reason: 'Repeated tardiness - 3rd occurrence', date: 'Apr 2, 2025', requires: 'Formal documentation required',
      file: 'Three documented tardiness incidents: Jan 14 (18 min), Feb 3 (22 min), Apr 2 (31 min). Employee was verbally warned after first two incidents. Written warning issued Apr 2, 2025. Employee acknowledged receipt. Next occurrence may result in suspension.' },
    { id: 1, name: 'Jordan Collins', initials: 'JC', dept: 'Field Staff', num: 1, reason: 'Vehicle incident - at-fault', date: 'Apr 1, 2025', requires: 'Incident report filed',
      file: 'At-fault vehicle incident on Apr 1, 2025. Employee struck a curb while making a right turn, resulting in a flat tire and minor rim damage. Incident report #IR-2025-014 filed. Estimated repair cost: $340. Defensive driving refresher assigned.' },
  ])

  const recognition = [
    { name: 'Jamie Mitchell',  initials: 'JM', reason: 'Above & beyond - client event coverage', date: 'Apr 1',  dept: 'Operations'     },
    { name: 'Dana Lee',        initials: 'DL', reason: 'Perfect attendance - Q1 2025',           date: 'Mar 31', dept: 'Field Staff'     },
    { name: 'Sam Rivera',      initials: 'SR', reason: 'Onboarded 3 new hires flawlessly',       date: 'Mar 28', dept: 'Operations'     },
    { name: 'Kim Park',        initials: 'KP', reason: 'Resolved major scheduling conflict',     date: 'Mar 25', dept: 'Administrative'  },
    { name: 'Paula Reyes',     initials: 'PR', reason: 'Top customer satisfaction scores Q1',    date: 'Mar 20', dept: 'Customer Service'},
  ]

  const reviews = [
    { name: 'Jamie Mitchell',  initials: 'JM', score: 4.2, date: 'Dec 2024', next: 'Jun 2025', status: 'Complete',
      file: 'Annual review completed Dec 15, 2024. Score: 4.2/5.0. Strengths: reliability, teamwork, client communication. Growth areas: delegation, process documentation. Recommended for merit increase of 3.5%. Promoted to Operations Coordinator Jul 2024.' },
    { name: 'Sam Rivera',      initials: 'SR', score: 3.9, date: 'Dec 2024', next: 'Jun 2025', status: 'Complete',
      file: 'Annual review completed Dec 15, 2024. Score: 3.9/5.0. Meets expectations across all categories. Noted improvement in punctuality vs prior year. Goal set: complete advanced operations training by Q2 2025.' },
    { name: 'Kim Park',        initials: 'KP', score: 4.6, date: 'Dec 2024', next: 'Jun 2025', status: 'Complete',
      file: 'Annual review completed Dec 15, 2024. Score: 4.6/5.0 - highest on team. Exceptional organizational skills and administrative accuracy. Zero errors on payroll submissions all year. Flagged as high-retention priority.' },
    { name: 'Dana Lee',        initials: 'DL', score: 4.1, date: 'Sep 2024', next: 'Sep 2025', status: 'Complete',
      file: '6-month review completed Sep 15, 2024. Score: 4.1/5.0. Strong start in field coordinator role. Quickly learned routes and client protocols. Recommended for full-time status conversion.' },
    { name: 'Marcus Thomas',   initials: 'MT', score: 2.8, date: 'Dec 2024', next: 'Jun 2025', status: 'Complete',
      file: 'Annual review completed Dec 15, 2024. Score: 2.8/5.0 - below expectations. Attendance and punctuality are primary concerns (3 warnings issued). Performance improvement plan initiated Jan 2025. 90-day check-in required.' },
    { name: 'Tyler Walsh',     initials: 'TW', score: null, date: '--',      next: 'Jun 2025', status: 'Pending',
      file: 'Review not yet completed. Scheduled for Jun 2025.' },
  ]

  const av = (initials, color=accent) => (
    <div style={{width:32,height:32,borderRadius:'50%',background:color+'22',color,display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:700,flexShrink:0}}>{initials}</div>
  )

  const tabs = ['warnings','recognition','reviews']

  return (
    <div style={{fontFamily:"'Montserrat',sans-serif"}}>

      {/* Modal */}
      {modal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.35)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}} onClick={()=>setModal(null)}>
          <div style={{background:'#fff',borderRadius:12,width:'100%',maxWidth:520,boxShadow:'0 8px 40px rgba(0,0,0,0.18)'}} onClick={e=>e.stopPropagation()}>
            <div style={{padding:'18px 24px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div>
                <div style={{fontFamily:'Georgia,serif',fontSize:16,fontWeight:600,color:'#2B2B2B'}}>{modal.name}</div>
                <div style={{fontSize:11,color:'#8A9E8A',marginTop:2}}>{modal.type}</div>
              </div>
              <button onClick={()=>setModal(null)} style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'#8A9E8A',lineHeight:1}}>&times;</button>
            </div>
            <div style={{padding:'20px 24px'}}>
              <div style={{fontSize:13,color:'#4A4A4A',lineHeight:1.8,whiteSpace:'pre-wrap'}}>{modal.content}</div>
            </div>
            <div style={{padding:'14px 24px',borderTop:'1px solid #EDE6DA',display:'flex',justifyContent:'flex-end',gap:10}}>
              <button onClick={()=>setModal(null)} style={{padding:'7px 18px',border:'1px solid #EDE6DA',borderRadius:6,background:'#fff',fontSize:12,fontWeight:600,color:'#4A4A4A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Close</button>
              <button style={{padding:'7px 18px',border:'none',borderRadius:6,background:accent,fontSize:12,fontWeight:600,color:'#fff',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Download PDF</button>
            </div>
          </div>
        </div>
      )}

      <div style={{marginBottom:20}}>
        <h1 style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600}}>Performance</h1>
        <p style={{fontSize:11,color:'#6B7D6B',marginTop:2}}>Warnings, recognition, and performance reviews</p>
      </div>

      {/* Tab bar */}
      <div style={{display:'flex',background:'#fff',border:'1px solid #EDE6DA',borderRadius:8,overflow:'hidden',marginBottom:16,width:'fit-content'}}>
        {tabs.map(t => (
          <button key={t} onClick={()=>setActiveTab(t)} style={{padding:'8px 20px',border:'none',borderRight:'1px solid #EDE6DA',background:activeTab===t?accent:'#fff',color:activeTab===t?'#fff':'#4A4A4A',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",textTransform:'capitalize',transition:'all 0.15s'}}>
            {t === 'warnings' ? `Warnings (${warnings.length})` : t === 'recognition' ? `Recognition (${recognition.length})` : 'Reviews'}
          </button>
        ))}
      </div>

      {/* Warnings */}
      {activeTab === 'warnings' && (
        <div style={{display:'flex',flexDirection:'column',gap:12}}>
          {warnings.map(w => (
            <div key={w.id} style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,padding:'16px 20px'}}>
              <div style={{display:'flex',alignItems:'flex-start',gap:14}}>
                <div style={{width:36,height:36,borderRadius:'50%',background:'rgba(160,57,43,0.1)',border:'2px solid #A0392B',display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:700,color:'#A0392B',flexShrink:0}}>
                  {w.num}
                </div>
                <div style={{flex:1}}>
                  <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:4}}>
                    <div style={{fontSize:14,fontWeight:600,color:'#2B2B2B'}}>{w.name}</div>
                    <span style={{fontSize:10,padding:'2px 7px',borderRadius:8,fontWeight:600,background:'rgba(107,125,107,0.08)',color:'#6B7D6B'}}>{w.dept}</span>
                    <span style={{fontSize:10,padding:'2px 7px',borderRadius:8,fontWeight:600,background:'rgba(160,57,43,0.1)',color:'#A0392B'}}>Warning #{w.num}</span>
                  </div>
                  <div style={{fontSize:13,color:'#4A4A4A',marginBottom:4}}>{w.reason}</div>
                  <div style={{fontSize:11,color:'#8A9E8A'}}>{w.requires} &middot; {w.date}</div>
                </div>
                <div style={{display:'flex',gap:8}}>
                  <button onClick={()=>setModal({name:w.name, type:'Warning File', content:w.file})} style={{padding:'6px 14px',border:'1px solid #EDE6DA',borderRadius:6,background:'#fff',fontSize:11,fontWeight:600,color:'#4A4A4A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>View File</button>
                  <button style={{padding:'6px 14px',border:'1px solid #A0392B',borderRadius:6,background:'rgba(160,57,43,0.08)',fontSize:11,fontWeight:600,color:'#A0392B',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>+ Add Note</button>
                </div>
              </div>
            </div>
          ))}
          <button style={{padding:'10px',border:'2px dashed #EDE6DA',borderRadius:10,background:'transparent',fontSize:12,fontWeight:600,color:'#8A9E8A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
            + Issue New Warning
          </button>
        </div>
      )}

      {/* Recognition */}
      {activeTab === 'recognition' && (
        <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
          <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Recognition Log</div>
            <button style={{padding:'6px 14px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>+ Add Recognition</button>
          </div>
          {recognition.map((r,i) => (
            <div key={i} style={{display:'flex',alignItems:'center',gap:12,padding:'14px 16px',borderBottom:i<recognition.length-1?'1px solid #EDE6DA':'none'}}>
              <span style={{color:accent,fontSize:18,lineHeight:1,flexShrink:0}}>&#9733;</span>
              {av(r.initials)}
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:500,color:'#2B2B2B'}}>{r.name} <span style={{fontSize:11,color:'#8A9E8A',fontWeight:400}}>&middot; {r.dept}</span></div>
                <div style={{fontSize:12,color:'#6B7D6B'}}>{r.reason}</div>
              </div>
              <div style={{fontSize:11,color:'#8A9E8A',flexShrink:0}}>{r.date}</div>
            </div>
          ))}
        </div>
      )}

      {/* Reviews */}
      {activeTab === 'reviews' && (
        <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
          <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Performance Reviews</div>
            <button style={{padding:'6px 14px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>+ New Review</button>
          </div>
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
            <thead>
              <tr style={{background:'#F7F2EB'}}>
                {['Employee','Score','Last Review','Next Review','Status',''].map(h=>(
                  <th key={h} style={{textAlign:'left',padding:'8px 16px',fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,borderBottom:'1px solid #EDE6DA'}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {reviews.map((r,i)=>(
                <tr key={i} style={{borderBottom:'1px solid #EDE6DA'}}>
                  <td style={{padding:'12px 16px'}}>
                    <div style={{display:'flex',alignItems:'center',gap:8}}>{av(r.initials)}<span style={{fontWeight:500,color:'#2B2B2B'}}>{r.name}</span></div>
                  </td>
                  <td style={{padding:'12px 16px'}}>
                    {r.score ? (
                      <div style={{display:'flex',alignItems:'center',gap:6}}>
                        <span style={{fontFamily:'Georgia,serif',fontSize:16,color:r.score>=4?'#4A7C59':r.score>=3?accent:'#A0392B',fontWeight:600}}>{r.score}</span>
                        <span style={{fontSize:11,color:'#8A9E8A'}}>/5</span>
                      </div>
                    ) : <span style={{color:'#8A9E8A'}}>--</span>}
                  </td>
                  <td style={{padding:'12px 16px',color:'#4A4A4A'}}>{r.date}</td>
                  <td style={{padding:'12px 16px',color:'#4A4A4A'}}>{r.next}</td>
                  <td style={{padding:'12px 16px'}}>
                    <span style={{fontSize:10,padding:'2px 8px',borderRadius:8,fontWeight:600,background:r.status==='Complete'?'rgba(74,124,89,0.1)':accentBg,color:r.status==='Complete'?'#4A7C59':accent}}>{r.status}</span>
                  </td>
                  <td style={{padding:'12px 16px'}}>
                    <button onClick={()=>setModal({name:r.name, type:'Performance Review - '+r.date, content:r.file})} style={{padding:'4px 10px',border:'1px solid #EDE6DA',borderRadius:5,background:'#fff',fontSize:11,color:'#6B7D6B',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>View</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
